import virus1 from "../../Assets/Home/Common/virus1.png";
import virus2 from "../../Assets/Home/Common/virus2.png";
import virus3 from "../../Assets/Home/Common/virus3.png";
import virus4 from "../../Assets/Home/Common/virus4.png";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import logo from "../../Assets/Logos/f-logo.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";

const UserFooter = () => {
  const [categories, setCategories] = useState(null);
  const [loading, setLoading] = useState(true);
  const [subService, setSubService] = useState(null);
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/category/fetch-all`
        // { withCredentials: true }
      );
      setCategories(response.data);
      await response.data?.map((cat, index) => fetchSubcategories(cat?._id));
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubcategories = async (categoryId) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/subcategory/get-by-id/${categoryId}`
        // { withCredentials: true }
      );
      if (response.data?.length !== 0) setSubService(response.data);
      // console.log(response.data)
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    } finally {
      setLoading(false);
    }
  };

  // console.log(subService)

  // const handleServiceNavigation = (serviceId) => {
  //   navigate(`/service/${serviceId}`);
  //   window.scrollTo(0, 0);
  // };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div className="relative bg-black md:py-16 py-6 md:px-10 px-6 text-white overflow-hidden">
      <style>{`
        @keyframes bounce-left {
          0%, 100% { transform: translateX(0); }
          50% { transform: translateX(-1rem); }
        }
        @keyframes bounce-right {
          0%, 100% { transform: translateX(0); }
          50% { transform: translateX(1rem); }
        }
        @keyframes bounce-up {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-1rem); }
        }
        @keyframes bounce-down {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(1rem); }
        }
        .animate-bounce-left {
          animation: bounce-left 2s infinite;
        }
        .animate-bounce-right {
          animation: bounce-right 2s infinite;
        }
        .animate-bounce-up {
          animation: bounce-up 2s infinite;
        }
        .animate-bounce-down {
          animation: bounce-down 2s infinite;
        }

        @keyframes slide-right-to-left {
          0% {
            transform: translateX(100%);
          }
          100% {
            transform: translateX(-100%);
          }
        }
        .marquee-text {
          animation: slide-right-to-left 100s linear infinite;
        }
      `}</style>
      <div className="relative pt-20 ">
        {/* Decorative images */}
        <img
          src={virus4}
          alt="decor"
          className="absolute top-10 left-20 w-16 h-16 animate-bounce-down pointer-events-none"
        />
        <img
          src={virus2}
          alt="decor"
          className="absolute bottom-20 right-10 w-16 h-16 animate-bounce-up pointer-events-none"
        />
        <img
          src={virus1}
          alt="decor"
          className="absolute top-10 right-10 w-16 h-16 animate-bounce-left pointer-events-none"
        />
        <img
          src={virus3}
          alt="decor"
          className="absolute bottom-10 left-10 w-16 h-16 animate-bounce-right pointer-events-none"
        />

        <div className="max-w-5xl mx-auto flex flex-col relative z-10">
          <div className="flex xl:flex-row flex-col justify-between items-center gap-10">
            <div className="">
              <h1 className="xl:text-3xl text-2xl font-bold familjen-font mb-2">
                Need help on Emergency? Book Your Appointment Today.
              </h1>
            </div>
            <div className="flex md:flex-row flex-col md:items-center items-stretch gap-4">
              <button
                className="whitespace-nowrap px-8 familjen-font py-3 bg-cyan-500 text-white font-semibold rounded-md hover:bg-cyan-600 transition-colors"
                onClick={() => {
                  navigate("/book-inquiry");
                  window.scrollTo(0, 0);
                }}
              >
                MAKE APPOINTMENT
              </button>
              <a
                href="tel:+917077560648"
                className="whitespace-nowrap familjen-font cursor-pointer px-8 py-3 bg-white text-black font-semibold rounded-md  transition-colors"
              >
                +91 7077560648
              </a>
            </div>
          </div>
          <div className="bg-white h-0.5 w-full mx-auto my-10"></div>
          {/* Main Footer Content */}
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Logo/Contact Section */}
            <div className="md:col-span-1">
              <div
                className="flex items-center gap-3 mb-4 cursor-pointer"
                onClick={() => handleNavigation("/")}
              >
                <img
                  src={logo}
                  alt="logo"
                  className="w-12 h-12 bg-cyan-500 rounded-full flex items-center justify-center "
                />

                <h2 className="text-2xl font-bold familjen-font">Diagnonext</h2>
              </div>
              <div className="space-y-2 mb-4">
                <div className="flex items-center gap-2">
                  <FaMapMarkerAlt className="text-cyan-400" />
                  <span>1840/3294/4628, Balianta, Hanspal, Bbsr</span>
                </div>
                <div className="flex items-center gap-2">
                  <FaEnvelope className="text-cyan-400" />
                  <a href="mailto:managingdirector@diagnonextlabs.com" className="cursor-pointer">managingdirector@diagnonextlabs.com</a>
                </div>

                <div className="flex items-center gap-2">
                  <FaPhone className="text-cyan-400" />
                  <div className="flex flex-col divide-y-2 divide-gray-600">
                    <a href="tel:+917077560638" className="cursor-pointer">
                      +91 7077560638
                    </a>
                    <a href="tel:+917077560648" className="cursor-pointer">
                      +91 7077560648
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="md:col-span-1">
              <h3 className="text-xl font-semibold mb-4 familjen-font">
                Quick Links
              </h3>
              <ul className="md:space-y-1 space-y-2 text-sm">
                <li
                  className="hover:text-cyan-400 w-fit transition-colors cursor-pointer"
                  onClick={() => handleNavigation("/about")}
                >
                  About Us
                </li>
                <li
                  className="hover:text-cyan-400 w-fit transition-colors cursor-pointer"
                  onClick={() => handleNavigation("/contact")}
                >
                  Contact
                </li>
                <li
                  className="hover:text-cyan-400 w-fit transition-colors cursor-pointer"
                  onClick={() => handleNavigation("/package")}
                >
                  Package's
                </li>
                <li
                  className="hover:text-cyan-400 w-fit transition-colors cursor-pointer"
                  onClick={() => handleNavigation("/blog")}
                >
                  Blog's
                </li>
                <li
                  className="hover:text-cyan-400 w-fit transition-colors cursor-pointer"
                  onClick={() => handleNavigation("/gallery")}
                >
                  Gallery
                </li>
                <li
                  className="hover:text-cyan-400 w-fit transition-colors cursor-pointer"
                  onClick={() => handleNavigation("/career")}
                >
                  Career
                </li>
                <li
                  className="hover:text-cyan-400 w-fit transition-colors cursor-pointer"
                  onClick={() => handleNavigation("/contact")}
                >
                  Contact
                </li>
                {/* <li className="hover:text-cyan-400 w-fit transition-colors cursor-pointer" onClick={() => handleNavigation('/team-members')}>Team Member</li> */}
              </ul>
            </div>

            {/* Our Service */}
            <div className="md:col-span-1">
              <h3 className="text-xl font-semibold mb-4 familjen-font">
                Our Service
              </h3>
              <ul className="space-y-2 text-sm">
                {subService?.map((sub, index) => (
                  <Link
                    key={index}
                    to={`/service/${sub._id}`}
                    className="hover:text-cyan-400 block transition-colors cursor-pointer"
                  >
                    {sub?.title}
                  </Link>
                ))}
              </ul>
            </div>

            {/* Newsletter */}
            {/* <div className="md:col-span-1">
              <h3 className="text-xl font-semibold mb-4 familjen-font">
                Newsletter
              </h3>
              <p className="text-sm mb-4 opacity-80">
                Build responsive, mobile-first projects on the web with the
                world’s most popular front-end component library
              </p>
              <div className="flex w-full">
                <input
                  type="email"
                  placeholder="Your Email Address"
                  className="w-full px-4 py-2 bg-black border border-gray-600 rounded-l-md text-white placeholder-gray-400 focus:outline-none focus:border-cyan-500"
                />
                <button className="bg-cyan-500 px-4 py-2 rounded-r-md hover:bg-cyan-600 transition-colors ">
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 7l5 5m0 0l-5 5m5-5H6"
                    />
                  </svg>
                </button>
              </div>
            </div> */}
          </div>

          {/* Bottom Copyright and Social */}
          <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex flex-col">
              <p className="text-sm opacity-80">
                © {currentYear} DIAGNONEXT{" "} | All Rights Reserved
              </p>
              <p className="text-sm opacity-80">Designed & Developed by <a
                href="https://www.webbocket.com/"
                className="text-orange-500 hover:underline font-bold familjen-font"
              >
                Web_Bocket PVT LTD.
              </a></p>
            </div>
            <div className="flex gap-4">
              <FaFacebookF className="text-xl hover:text-cyan-400 transition-colors cursor-pointer" />
              <FaSquareXTwitter className="text-xl hover:text-cyan-400 transition-colors cursor-pointer" />
              <FaInstagram className="text-xl hover:text-cyan-400 transition-colors cursor-pointer" />
              <FaLinkedinIn className="text-xl hover:text-cyan-400 transition-colors cursor-pointer" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFooter;
